/*
*   CH
*   公共方法类整合 class
*   2018/12/10 
*
* */

class Common{
    constructor(){
        // 正则区域
        let _ = this;
        _.reg_phone = /^1[3456789]\d{9}$/;
        _.reg_qq = /^[1-9]*[1-9][0-9]*$/;
        _.reg_email = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        _.reg_pwd = /^[0-9A-Za-z]{6,15}$/;
        _.reg_name = /^([a-zA-Z0-9\u4e00-\u9fa5\·]{1,10})$/;
        _.reg_idCard = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        _.reg_money = /^\d+(\.\d+)?|[1-9]\d*\.\d*|0\.\d*[1-9]\d*|0?\.0+|0$/;
        _.reg_moneyZ = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
        _.reg_numberZ = /^[0-9]+$/;
        _.reg_numberF = /^-[1-9]\d*|(-([1-9]\d*\.\d*|0\.\d*[1-9]\d*))|0?\.0+(-([1-9]\d*\.\d*|0\.\d*[1-9]\d*))|0?\.0+$/;
    }
    /* 获取头部信息 */
    getQueryString(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r != null){
            return r[2];
        }
    }
    /* 获取URL所有参数 */
    getURLRs(name){
        var rs = name.split("?");
        return rs.length > 1 ? rs = rs[1] : rs = "";
    };
    
    /**
     * 替换空格
     * 2017/11/17
    */ 
    htmlBr(key) {  
        key = key.replace(/<\/?.+?>/g,""); 
        key = key.replace(/[\r\n]/g, " <br />"); 
        return key; 
    }
    /**
     * 格式化参数
     * 2019/11/07
    */
    formatParams(data) {
        let _url = ''
        if (data && Object.keys(data).length > 0) {
            const _data = Object.keys(data)
            _data.map(i => {
                if (data[i] !== '') {
                    _url += `&${i}=${data[i]}`
                }
            })
            _url = _url.substr(1)
        }
        return _url
    }

}

const common = new Common();

export default common



// WEBPACK FOOTER //
// ./src/utils/common.js